/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  AccountingSettingsDto,
  UpdateAccountingSettingsRequest,
  UpdateAccountingSettingsResponse,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiAccountingSettingsController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-accounting-settings-controller
   * @name CreateOrUpdateAccountingSettings
   * @request PUT:/api/v1/reimbursement/organisation/accounting-settings/{lineType}
   */
  createOrUpdateAccountingSettings = (
    lineType: 'EXPENSE' | 'MILEAGE' | 'PER_DIEM',
    data: UpdateAccountingSettingsRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<UpdateAccountingSettingsResponse, any>({
      path: `/v1/reimbursement/organisation/accounting-settings/${lineType}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createOrUpdateAccountingSettingsPath =
    '/v1/reimbursement/organisation/accounting-settings/${lineType}'
  static createOrUpdateAccountingSettingsMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-accounting-settings-controller
   * @name FindAllAccountingSettings
   * @request GET:/api/v1/reimbursement/organisation/accounting-settings
   */
  findAllAccountingSettings = (params: RequestParams = {}) =>
    this.http.request<AccountingSettingsDto[], any>({
      path: `/v1/reimbursement/organisation/accounting-settings`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findAllAccountingSettingsPath = '/v1/reimbursement/organisation/accounting-settings'
  static findAllAccountingSettingsMethod = 'GET'
}
